import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Utils from './../../../../../utils/Utils';
import Icons from "../../../../../assets/Icons/Icons";
import WalletPreview from './WalletPreview/WalletPreview';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import './WalletManagement.scss';
import * as stateActions from "../../../../../store/actions";
import { requestWallet as requestWinnerFunWallet } from "../../../../../winner-fun/store/actions/wallet";

const HOME = 'walletHome';
const SPORTSBOOK = 'walletSportsbook';
const CASINO = 'walletCasino';
const CASINO_LIVE = 'walletCasinoLive';
const VIRTUALS = 'walletVirtuals';
const LOTTO = 'walletLotto';
const WINNER_FUN = 'walletWinnerFun';

const CASINO_ID = 1;
const SPORTSBOOK_ID = 2;
const CASINO_LIVE_ID = 4;
const VIRTUALS_ID = 999; //To be defined
const LOTTO_ID = 3;
const WINNER_FUN_ID = 6;

const WalletManagement = (props) => {
    const { wallet, winnerFunWallet, reloadWallet, getWinnerFunWallet, history } = props;

    const [isVisible, setIsVisible] = useState(false);
    const [currentWallet, setCurrentWallet] = useState(0);
    const [productType, setProductType] = useState(HOME);

    const getCurrentWallet = (id) => {
        if (window.config && window.config.winnerFunEnabled === "1" && id === WINNER_FUN_ID) {
            if (!winnerFunWallet.loadingWallet) {
                setCurrentWallet(winnerFunWallet ? winnerFunWallet.total : 0);
                return;
            }
        } else if (!wallet.loadingWallet) {
            if (wallet.walletManagement[id] && wallet.walletManagement[id].productAmount) {
                setCurrentWallet(wallet.walletManagement[id].productAmount);
                return;
            } else {
                setCurrentWallet(wallet.main);
                return;
            }
        }
        setCurrentWallet(0);
        return;
    }

    useEffect(() => {
        let path = '';
        let alreadySet = false;

        if (history.location.pathname) {
            path = history.location.pathname;

            if (path.search('pariuri') > 0) {
                setProductType(SPORTSBOOK);
                getCurrentWallet(SPORTSBOOK_ID);
                alreadySet = true;
            }

            if (path.search('cazino_live') > 0) {
                setProductType(CASINO_LIVE);
                getCurrentWallet(CASINO_LIVE_ID);
                alreadySet = true;
            } else if ((path.search('profile') > 0) || (path.search('promotii') > 0)) {
                setProductType(HOME);
                setCurrentWallet(wallet.total);
                alreadySet = true;
            } else if ((path.search('cazino') > 0) || (path.search('casino') > 0) || (path.search('table-games') > 0) || path === '/') {
                setProductType(CASINO);
                getCurrentWallet(CASINO_ID);
                alreadySet = true;
            }

            if (path.search('virtuale') > 0) {
                setProductType(VIRTUALS);
                getCurrentWallet(VIRTUALS_ID);
                alreadySet = true;
            }

            if (path.search('lotto') > 0) {
                setProductType(LOTTO);
                getCurrentWallet(LOTTO_ID);
                alreadySet = true;
            }

            if (path.search('winner-fun') > 0) {
                setProductType(WINNER_FUN);
                getCurrentWallet(WINNER_FUN_ID);
                alreadySet = true;
            }
        }

        if (!alreadySet) {
            setProductType(HOME);
            setCurrentWallet(wallet.total);
        }

    }, [history.location.pathname, wallet, winnerFunWallet]);

    const toggleWalletPreview = () => {
        if (isVisible) {
            setTimeout(() => {
                setIsVisible(isV => !isV);
            }, 300);
        } else {
            reloadWallet();
            if (productType === WINNER_FUN) {
                getWinnerFunWallet();
            }
            setIsVisible(!isVisible);
        }
    }

    const goToDeposit = () => {
        if (window.config && window.config.winnerFunEnabled === "1" && productType === WINNER_FUN && typeof props.onWinnerFunDrawer === "function") {
            props.onWinnerFunDrawer();
            return;
        }
        history.push('/deposit');
    };

    let mainContent = (
        <div className="WalletTopWidget">
            <div className="WalletType" onClick={() => toggleWalletPreview()}>
                <i>
                    {Icons.get(productType, 'PreviewIcon ' + productType)}
                    <ArrowDropDownIcon className="DropDownIcon" />
                </i>
            </div>
            <div className="WalletAmount">
                <span onClick={() => toggleWalletPreview()}>{Utils.formatSmallDecimals(currentWallet, null)}</span>
                <i onClick={() => goToDeposit()}>{Icons.get('walletWidgetAdd', 'WalletViewMore')}</i>
            </div>
        </div>
    );
    return (
        <div className={"WalletManagementScreen"}>
            <WalletPreview isVisible={isVisible} setIsVisible={() => toggleWalletPreview()} currentProduct={productType}/>
            {mainContent}
        </div>
    );
};
const mapDispatchToProps = dispatch => {
    return {
        reloadWallet: () => dispatch(stateActions.requestWalletPreview()),
        getWinnerFunWallet: () => dispatch(requestWinnerFunWallet()),
    };
};
const mapStateToProps = state => {
    return {
        wallet: state.wallet,
        winnerFunWallet: state.winnerFun && state.winnerFun.wallet ? state.winnerFun.wallet : null
    }
};

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(WalletManagement)));